import { ArrayField, Datagrid, FunctionField, TextField } from 'react-admin';

export const formatMol = (value: unknown) =>
    value == null || value === '' ? '-' : Number(value).toExponential(3);

export const IntegralResultsTable = () => (
    <ArrayField source="integral_results" label={false}>
        <Datagrid bulkActionButtons={false} rowClick={false}>
            <TextField source="sample_name" label="Sample" />
            <TextField source="start" label="Start [s]" />
            <TextField source="end" label="End [s]" />
            <FunctionField
                label="Electrons transferred [mol]"
                render={record => formatMol(record.area)}
            />
        </Datagrid>
    </ArrayField>
);

export default IntegralResultsTable;
